export function replaceSavedPostUrl(text, previousUrl, nextUrl) {
  const source = String(text || '');
  if (!/^https?:\/\//i.test(previousUrl || '') || previousUrl === nextUrl) return source;
  return source.split(previousUrl).join(nextUrl || '');
}

export function ensureInsidePostLink(content, linkUrl) {
  const source = String(content || '');
  const url = String(linkUrl || '').trim();
  if (!/^https?:\/\//i.test(url)) return source;
  if (source.includes(url)) return source;
  const trimmed = source.replace(/\s+$/, '');
  if (!trimmed) return url;
  return `${trimmed}\n\n${url}`;
}
